export const INPUT_STATE = {
  tooLowHard: "tooLowHard",
  tooLowSoft: "tooLowSoft",
  expected: "expected",
  tooHighSoft: "tooHighSoft",
  tooHighHard: "tooHighHard",
} as const;

export type InputState = (typeof INPUT_STATE)[keyof typeof INPUT_STATE];
export const TOO_LOW_INPUT_STATES: InputState[] = [INPUT_STATE.tooLowHard, INPUT_STATE.tooLowSoft];
export const TOO_HIGH_INPUT_STATES: InputState[] = [INPUT_STATE.tooHighHard, INPUT_STATE.tooHighSoft];
export const HARD_INPUT_STATES: InputState[] = [INPUT_STATE.tooHighHard, INPUT_STATE.tooLowHard];
export const UNEXPECTED_INPUT_STATES: InputState[] = [INPUT_STATE.tooHighHard, INPUT_STATE.tooHighSoft, INPUT_STATE.tooLowHard, INPUT_STATE.tooLowSoft];
